<template>
  <div class="footer">
    <div class="content">
      <div class="inner">
        <el-row :gutter="20">
          <el-col :span="3">
            <div class="grid-content">
              <el-image v-if="companyLogo" class="project-logo" :src="companyLogo" alt="logo"></el-image>
              <img v-else class="project-logo" src="https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/default_icon.png" alt="logo" style="width:40px" />
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content">
              <div class="grid-title">{{ companyName ? companyName : ''}}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content">
              <div class="grid-title">产品</div>
              <div class="pointer" @click="toUrl('/cps')">上海-预配舱单</div>
              <div class="pointer" @click="toUrl('/vgm')">VGM发送</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="copy">
      <span>浙ICP备20009552号 © 2022杭州未斯科技有限公司<a href="https://beian.miit.gov.cn/" target="_blank" class="text-col-3 mx-2"> 浙ICP备20009552号-7</a></span>
    </div>
  </div>

</template>

<script>
import { httpAjax,httpAgent } from '@/api/ajax'
import DialogLogin from "./DialogLogin"
export default {
  name: "Footer",
  components: { DialogLogin },
  data () {
    return {
      loginVisible: false,
      loginSuccessUrl: '',
      companyLogo: '',
      companyName: ''
    }
  },
  mounted () {
    this.getDomainInfo();
  },
  methods: {
    toUrl (url) {
      if (this.$store.getters.isLogin) {
        this.$router.push({ path: url })
      } else {
        // this.loginSuccessUrl = url
        // this.loginVisible = true
        this.$router.push({ name: "register" })
      }
    },
    toAboutUs (top) {
      this.$router.push({ name: 'aboutUs' })
      this.$emit('setScrollTop', top)
    },
    toContactUs () {
      this.$router.push({ name: 'contactUs' })
      this.$emit('setScrollTop', 0)
    },
    //  关闭弹窗
    closeDialog () {
      this.loginVisible = false
      // this.toHome()
    },
    toHome () {
      this.$router.push({ name: 'login' })
      this.type = 0
      sessionStorage.removeItem("tabIndex")
      this.$emit('setScrollTop', 0)
    },
    //获取当前域名企业信息
    getDomainInfo () {
      httpAgent({
        url: `${location.hostname == 'localhost' ? 'http://gateway.eline56.test' : ''}/agent/config/preGet`,
        method: "get",
      }).then((res) => {
        if (res.id) {
          this.companyName = res.companyName;
          if(res.companyLogo){
            if(res.companyLogo.indexOf('http') > -1){
              this.companyLogo = res.companyLogo
            }else{
              this.companyLogo = 'https://' + res.companyLogo
            }
          }
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
          link.type = 'image/x-icon';
          link.rel = 'shortcut icon';
          link.href = this.companyLogo;
          document.getElementsByTagName('head')[0].appendChild(link);
        }else{
          this.$router.push({
            name:'notFind'
          })
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.footer {
  position: relative;
  z-index: 99;
  .content {
    padding: 48px 0;
    background-color: white;
    .inner {
      width: 1200px;
      margin: 0 auto;
      .grid-content {
        line-height: 24px;
        font-size: 14px;
        color: #666666;
        .grid-title {
          font-size: 16px;
          color: #333333;
          font-weight: 600;
          padding-bottom: 12px;
        }
        .project-logo {
          width: 108px;
          ::v-deep .el-image__inner {
            width: 100%;
          }
        }
      }
      .grid-code {
        font-size: 14px;
        text-align: center;
        .qr-code {
          width: 120px;
          height: 120px;
          margin-bottom: 12px;
        }
        & > div {
          color: #333333;
          font-weight: 600;
        }
      }
    }
  }
  .copy {
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-weight: 400;
    text-align: center;
    font-size: 12px;
    color: #666666;
  }
}
.pointer {
  cursor: pointer;
}
</style>